import "clsx";
function _page($$payload) {
  $$payload.out += `<h1>test 2</h1>`;
}
export {
  _page as default
};
